import { motion } from "framer-motion"; // For modal entrance animations
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { Box, Typography } from "@mui/material";
import HtmlContent from "../../components/html-content/HtmlContent";
import BirdIllustration from "../../assets/images/celebration-images/celeb_bird.png";
import CloudImage from "../../assets/images/celebration-images/celeb_cloud.png";
import { Celebrations } from "../../utility/interfaces/carePlanInterfaces";
import { useTranslation } from "react-i18next";

interface BabyBornProps {
  onClose: (celebration: Celebrations) => void;
  celebration: Celebrations;
}

export const BabyBorn: React.FC<BabyBornProps> = ({ onClose, celebration }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="modal modal--birth"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="modal__cloud-section">
        <div className="custom-cloud-layer">
          <img
            src={CloudImage}
            alt="Cloud"
            className="cloud cloud--sm cloud--1"
          />
          <img
            src={CloudImage}
            alt="Cloud"
            className="cloud cloud--sm cloud--2"
          />
          <img
            src={CloudImage}
            alt="Cloud"
            className="cloud cloud--sm cloud--3"
          />
        </div>
        <motion.div
          className="modal__duck-wrapper"
          animate={{ y: [0, -5, 0, 5, 0], rotate: [0, 1.5, -1.5, 0] }}
          transition={{ repeat: Infinity, duration: 5 }}
        >
          <img
            src={BirdIllustration}
            alt="Flying Duck"
            className="modal__duck"
          />
        </motion.div>
      </div>
      <Typography variant="body1" mb={3} className="celebration">
        <HtmlContent htmlString={celebration.content || "NA"} />
      </Typography>
      <Box sx={{ paddingTop: "24px" }}>
        <CustomButton
          onClick={() => onClose(celebration)}
          variant="contained"
          text={t("noShowAppointment.closeButton")}
        />
      </Box>
    </motion.div>
  );
};
